export interface Logo {
  fileName: string;
  fileType: string;
  url: string;
}
